export default __webpack_public_path__ + "static/media/cases2.a513b44a.jpg";